import React from "react";

const AsideHeader = ({ clientName }) => {
  return (
    <div className="flex flex-col gap-y-2 py-2 px-3">
      <div className="flex w-full  items-center h-[100px] gap-x-2">
        <h1 className="font-semibold text-xl italic font-Roboto tracking-wide text-pink-600 leading-relaxed shadow-sm">
          {clientName}
        </h1>
        <img
          src={"/images/Icons/mariposa-icon.png"}
          alt="logo"
          className="w-[50px] h-[auto] object-cover"
        />
      </div>
    </div>
  );
};

export default AsideHeader;
